import React from 'react';

// Sample JSON data
const jsonData = [
    { id: 1, name: 'शराब की लत का उपचार', url: '/alcohol-addiction-treatment-patna-hin' },
    { id: 2, name: 'कोकीन की लत का उपचार', url: '/cocaine-addiction-treatment-patna-hin' },
    { id: 3, name: 'ड्रग्स की लत का उपचार', url: '/drug-addiction-treatment-patna-hin' },
    { id: 4, name: 'हेरोइन की लत का उपचार', url: '/heroin-addiction-treatment-patna-hin' },
    { id: 5, name: 'गांजा (भांग) की लत का उपचार', url: '/marijuana-addiction-treatment-patna-hin' },
    { id: 6, name: 'व्हाइटनर की लत का उपचार', url: '/whitener-addiction-treatment-patna-hin' },
    { id: 7, name: 'ब्राउन शुगर की लत का उपचार', url: '/brownsugar-addiction-treatment-patna-hin' },
    { id: 8, name: 'इंजेक्शन की लत का उपचार', url: '/injection-addiction-treatment-patna-hin' },
    { id: 9, name: 'टैबलेट्स की लत का उपचार', url: '/tablet-addiction-treatment-patna-hin' },
    

  ];
  
export const Brandlink = () => {
    // Get current page URL path
  const currentPage = window.location.pathname;
    // Filter out the current page
    const filteredData = jsonData.filter((item) => item.url !== currentPage);
    
    return (
    <div className="main2 pregrahd">
    <div className='row'>
    {filteredData.map((item) => (
        <p key={item.id} className='col-md-3 col-sm-6 col-xs-12'>
          <a href={item.url}>{item.name}</a>
        </p>
      ))}   
        
    </div>
    </div>
)
}
